import React from 'react';
import { useLocation } from 'react-router-dom';
import menus from '../../config/app-menu.jsx';

const Breadcrumb = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter(i => i);
  
  // Simplified function to find menu item by path (including children)
  const findMenuItemByPath = (path, menuItems = menus, parentItems = []) => {
    for (const menuItem of menuItems) {
      // Create ancestry trail including this item
      const currentAncestry = [...parentItems, menuItem];
      
      // Check if this is the menu item we're looking for
      if (menuItem.path === path || menuItem.path === `/${path}`) {
        return currentAncestry;
      }
      
      // Check children recursively
      if (menuItem.children) {
        const foundInChildren = findMenuItemByPath(path, menuItem.children, currentAncestry);
        if (foundInChildren) return foundInChildren;
      }
    }
    return null;
  };
  
  // Build breadcrumb items from current path - simplified version
  const buildBreadcrumbItems = () => {
    // Start with Home
    const items = [{ label: 'Home' }];
    
    // For the full current path, try to find a matching menu item
    const fullPath = `/${pathSnippets.join('/')}`;
    const matchingItems = findMenuItemByPath(fullPath);
    
    if (matchingItems) {
      // We found a complete ancestry trail, add each ancestor title
      matchingItems.forEach(item => {
        items.push({ label: item.title });
      });
    } else {
      // No exact match found, just use formatted URL segments
      pathSnippets.forEach(snippet => {
        const label = snippet
          .replace(/-/g, ' ')
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        items.push({ label });
      });
    }
    
    return items;
  };
  
  const breadcrumbItems = buildBreadcrumbItems();
  
  return (
    <ol className="breadcrumb float-xl-end">
      {breadcrumbItems.map((item, index) => (
        <li key={index} className={`breadcrumb-item${index === breadcrumbItems.length - 1 ? ' active' : ''}`}>
          {item.label}
        </li>
      ))}
    </ol>
  );
};

export default Breadcrumb;